import styled, { css } from 'styled-components'
import {
	media,
	mediaOnly,
	Breakpoints,
	textModels,
	themeObject,
} from 'Pages/landings/newLandings/common/style'

export const ModalWrapper = styled.div<{ isClick: boolean; isOpen: boolean; hModal: number }>`
	display: flex;
	justify-content: center;
	align-items: end;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1000;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.45);
	box-sizing: border-box;
	@keyframes displayFlex {
		from {
			display: none;
		}
		to {
			display: flex;
		}
	}
	@keyframes displayNone {
		from {
			display: flex;
		}
		to {
			display: none;
		}
	}
	${({ isOpen, hModal }) =>
		isOpen &&
		hModal &&
		css`
			animation: displayNone 0.5s;
		`}
	${({ isClick }) =>
		isClick &&
		css`
			animation: displayFlex 0.5s;
		`}
`
export const Modal = styled.div<{
	hModal: number
	isClick: boolean
	isOpen: boolean
}>`
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	position: relative;
	background-color: white;
	padding: 24px;
	box-shadow: 0px 10px 20px rgb(0 0 0 / 25%);
	border-top-right-radius: 8px;
	border-top-left-radius: 8px;
	max-height: calc(100% - 32px);
	@keyframes go-up-down {
		from {
			bottom: 0px;
		}
		to {
			bottom: -${({ hModal }) => hModal}px;
		}
	}
	@keyframes go-down-up {
		from {
			bottom: -${({ hModal }) => hModal}px;
		}
		to {
			bottom: 0px;
		}
	}
	${({ isOpen, hModal }) => isOpen && hModal && 'animation: go-down-up 0.5s;'}
	${({ isClick }) => isClick && 'animation: go-up-down 0.5s;'}
`
export const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
	padding-bottom: 24px;
	border-bottom: 1px solid ${themeObject.colors.grey[200]};
	${media('margin-bottom: 32px;', Breakpoints.ms)}
`
export const ScrollBlock = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	${media('display: flex; flex-direction: column;', Breakpoints.ms)}
	${mediaOnly(`overflow-y: auto;`, '0px', Breakpoints.ms)}
`
export const Title = styled.p`
	${textModels('notAdaptive', 'h2')};
	color: ${themeObject.colors.grey[800]};
`
export const Footer = styled.div<{ isButtons: boolean }>`
	display: flex;
	padding-top: 24px;
	${({ isButtons }) =>
		isButtons &&
		css`
			height: 56px;
			align-items: center;
		`}
	border-top: 1px solid ${themeObject.colors.grey[200]};
`
